import { spacer, colors, radius, fontType } from 'settings/style';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  border: 1px dashed ${colors.red400};
  border-radius: ${radius.lg};
  padding: ${spacer.md};
  margin: ${spacer.md} 0;
`;

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: ${spacer.md};
  margin-top: ${spacer.md};
  align-items: baseline;
`;

export const StyledImgTitle = styled.p`
  ${fontType.nl};
  text-align: center;
  margin-bottom: ${spacer.md};
  color: ${colors.primary400};
`;
